import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { fromEvent } from 'rxjs';
import {
  domains,
  authServerIds,
  getOktaClientId,
} from '@global/infrastructure/constants/okta';
import { environment } from '@ren-env/environment';
import { Utility } from '@global/infrastructure/helpers/utility';
import { Environment } from '@global/infrastructure/models/environment';

declare const window: any;

@Component({
  selector: 'app-hidden-iframe',
  templateUrl: './hidden-iframe.component.html',
})
export class HiddenIframeComponent {
  sourceVAUrl;

  constructor(private sanitizer: DomSanitizer, private env: Environment) {
    fromEvent(window, 'va_in_progress').subscribe(() => {
      this.sourceVAUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        this.getOktaUrl('', 'VA')
      );
    });
  }

  /**
   * For exchange Okta Id token
   * Generate Okta Url for sending session token to
   * https://developer.okta.com/use_cases/authentication/session_cookie#retrieving-a-session-cookie-via-openid-connect-authorization-endpoint
   * @param login session token
   * @return Okta url
   */
  getOktaUrl(token: string, app?: string): string {
    const oktaUrl =
      '<oktaDomain>/oauth2/<authServerId>/v1/authorize?client_id=<clientId>&response_type=code&scope=openid&redirect_uri=<redirectUri>&state=<stateGuid>&prompt=none';
    return oktaUrl
      .replace(/<oktaDomain>/gi, this.getOktaParam('domain'))
      .replace(/<authServerId>/gi, this.getOktaParam('authServerId'))
      .replace(/<clientId>/gi, this.getOktaParam('clientId', app))
      .replace(
        /<redirectUri>/gi,
        window.location.protocol +
          '//' +
          window.location.host +
          '/my-dashboard/call-back'
      ) // Only absolute url is allowed for Okta redirect
      .replace(/<stateGuid>/gi, Utility.getUniqueId())
      .replace(/<nonceGuid>/gi, Utility.getUniqueId());
  }

  // This funciton will be similar to above but needs to get 'code' param from url
  vaIframeOnLoad(VAiframe) {
    const locationObj = VAiframe.contentWindow.location;
    let code;
    let search = '';

    if (locationObj.search && locationObj.search.indexOf('code=') !== -1) {
      search = locationObj.search;
      code = search.slice(search.indexOf('code=') + 5, search.indexOf('&'));
      this.addToken(code);
    }
  }

  private addToken(token) {
    const currTimestamp: any = Date.now();

    // Add token and time to window object in browser
    if (window.nuanceData && token) {
      window.nuanceData.va_tok = { tok: token, dateTime: currTimestamp };
    }
  }

  private getOktaParam(param: string, app?: string): string {
    const brand = environment.brand_copy.brandSimple;
    const production = this.env.production;
    const env = production ? 'prodSite' : 'devSite';

    switch (param) {
      case 'domain':
        return domains[brand][env];

      case 'authServerId':
        return authServerIds[brand][env];

      case 'clientId':
        return getOktaClientId(brand, env, app);

      default:
        return '';
    }
  }
}
